import React from 'react';
import * as styles from '../css/page-footer-slope.css';

const PageFooterSlope = () => (
    <div className={styles.root} />
);

export default PageFooterSlope;
